import Sequencing from './Sequencing';

export default Sequencing;
